import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { CotizadorService } from '../../services/cotizador.service';
import { Planes } from '../../models/planes';
import { Prospecto } from '../../models/prospecto';

@Component({
  selector: 'app-forma-pago',
  templateUrl: './forma-pago.component.html',
  styleUrls: ['./forma-pago.component.scss']
})
export class FormaPagoComponent implements OnInit {

  @Output() CambiaTab = new EventEmitter<number>();

  private unsubscribeAll: Subject<any>;
  planes: any;
  frecuencia: string;
  lblPrimaUDI: number;
  lblPrimaPesos: number;
  lblPrimaDolares: number;
  lblPrimaUDISecundaria: number;
  lblPrimaPesosSecundaria: number;
  lblPrimaDolaresSecundaria: number;
  valorUdi = '0';
  porcentageCargo = 0;
  leyendaSecundaria = '';
  etiquetaUdi = '';
  public formaPagoForm: FormGroup;
  muestraComision = false;
  prospecto: Prospecto;

  constructor(
    private formBuilder: FormBuilder,
    private cotizadorService: CotizadorService
  ) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit(): void {

    this.formaPagoForm = this.formBuilder.group({
      frecuencia: new FormControl('ANUAL'),

    });

    this.cotizadorService.getProspecto().subscribe((prospecto: Prospecto) => {

      this.prospecto = prospecto;

    });

    this.cotizadorService.obtenerValorUdi().subscribe(valorUdi => {
      if (valorUdi) {
        this.valorUdi = valorUdi.result;
      }
    });


    this.lblPrimaPesos = 0;
    this.lblPrimaDolares = 0;
    this.lblPrimaUDI = 0;
    this.cotizadorService.getPlanes().subscribe((planes: Planes) => {
 
      this.planes = planes;

      if (this.planes.fallPrimaPeso > 0 || this.planes.fallPrimaUdi > 0 || this.planes.fallPrimaDolares > 0) {
        this.muestraComision = true;

        if (this.planes.moneda === 'UDI') {
          const sumaPrimas = this.sumaPrimaUdi();
          this.lblPrimaUDI = sumaPrimas;
          this.lblPrimaPesos = sumaPrimas * +this.valorUdi;
          this.etiquetaUdi = ' UDI / ';
          this.cargaEtiquetasSecundariasUdi(sumaPrimas);


        } else if (this.planes.moneda === 'PESOS') {
          const sumaPrimas = this.sumaPrimaPesos();
          this.lblPrimaPesos = sumaPrimas;
          this.lblPrimaUDI = 0;
          this.etiquetaUdi = '';
          this.cargaEtiquetasSecundariasPesos(sumaPrimas);

        } else if (this.planes.moneda === 'DOLARES') {
          const sumaPrimas = this.sumaPrimaDolares();
          this.lblPrimaDolares = sumaPrimas;
          this.lblPrimaUDI = 0;
          this.lblPrimaPesos = 0;
          this.etiquetaUdi = '';
          this.cargaEtiquetasSecundariasDolares(sumaPrimas);

        }
      }
      else {
        this.muestraComision = false;
      }

    });

    /// //debugger;
    this.prospecto.formaPago = 'ANUAL';
    this.cotizadorService.setProspecto(this.prospecto);

  }


  onSelectChangeFrecuencia(evento: any): void {

    this.frecuencia = evento.value;

    if (this.frecuencia == "ANUAL") {
      this.porcentageCargo = 0;
    }
    if (this.frecuencia == "SEMESTRAL") {
      this.porcentageCargo = 0.035;
    }
    if (this.frecuencia == "TRIMESTRAL") {
      this.porcentageCargo = 0.05;
    }
    if (this.frecuencia == "MENSUAL") {
      this.porcentageCargo = 0.06;
    }

    if (this.planes.fallPrimaPeso > 0 || this.planes.fallPrimaPeso > 0) {

      if (this.planes.moneda === 'UDI') {
        const sumaPrimas = this.sumaPrimaUdi();
        this.lblPrimaUDI = sumaPrimas;
        this.lblPrimaPesos = sumaPrimas * +this.valorUdi;
        this.etiquetaUdi = ' UDI / ';
        this.cargaEtiquetasSecundariasUdi(sumaPrimas);


      } else if (this.planes.moneda === 'PESOS') {
        const sumaPrimas = this.sumaPrimaPesos();
        this.lblPrimaPesos = sumaPrimas;
        this.lblPrimaUDI = 0;
        this.etiquetaUdi = '';
        this.cargaEtiquetasSecundariasPesos(sumaPrimas);

      }
    }

    this.prospecto.formaPago = this.frecuencia;
    this.cotizadorService.setProspecto(this.prospecto);

  }

  /**
     * Este mÃ©todo se ejecuta cuando el componente es destruido y eliminamos las subscripciones que esten activas.
     */
  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  sumaPrimaUdi(): number {
    let resultado: number =

      +this.planes.fallPrimaUdi +
      this.planes.exenPrimaUdi +
      this.planes.pagoAdPrimaUdi +
      this.planes.conyuPrimaUdi +
      this.planes.mAcciPrimaUdi +
      this.planes.mPerOrgPrimaUdi +
      this.planes.mColePrimaUdi +
      this.planes.cancerPrimaUdi +
      this.planes.enfGravPrimaUdi +
      this.planes.desempPrimaUdi +
      this.planes.funePrimaUdi;

    return resultado;
  }


  sumaPrimaPesos(): number {
    let resultado: number =
      +this.planes.fallPrimaPeso +
      this.planes.exenPrimaPeso +
      this.planes.pagoAdPrimaPeso +
      this.planes.conyuPrimaPeso +
      this.planes.mAcciPrimaPeso +
      this.planes.mPerOrgPrimaPeso +
      this.planes.mColePrimaPeso +
      this.planes.cancerPrimaPeso +
      this.planes.enfGravPrimaPeso +
      this.planes.desempPrimaPeso +
      this.planes.funePrimaPeso;

    return resultado;
  }

  sumaPrimaDolares(): number {
    let resultado: number =
      +this.planes.fallPrimaDolares +
      this.planes.exenPrimaDolares +
      this.planes.pagoAdPrimaDolares +
      this.planes.conyuPrimaDolares +
      this.planes.mAcciPrimaDolares +
      this.planes.mPerOrgPrimaDolares +
      this.planes.mColePrimaDolares +
      this.planes.cancerPrimaDolares +
      this.planes.enfGravPrimaDolares +
      this.planes.desempPrimaDolares +
      this.planes.funePrimaDolares;

    return resultado;
  }

  udiToPeso(valorUdi: number): number {
    return +this.valorUdi * valorUdi;
  }

  cargaEtiquetasSecundariasUdi(sumaPrimas): void {
    let prima = 0;
    let frecuencia = this.formaPagoForm.controls.frecuencia.value;
    this.lblPrimaDolaresSecundaria = 0;
    switch (frecuencia) {
      case 'SEMESTRAL':
        prima = sumaPrimas / 2 * 1.035;
        this.lblPrimaUDISecundaria = prima;
        this.lblPrimaPesosSecundaria = prima * +this.valorUdi;
        this.leyendaSecundaria = 'Prima semestral: ';
        break;
      case 'TRIMESTRAL':
        prima = sumaPrimas / 4 * 1.05;
        this.lblPrimaUDISecundaria = prima;
        this.lblPrimaPesosSecundaria = prima * +this.valorUdi;
        this.leyendaSecundaria = 'Prima trimestral: ';
        break;
      case 'MENSUAL':
        prima = sumaPrimas / 12 * 1.06;
        this.lblPrimaUDISecundaria = prima;
        this.lblPrimaPesosSecundaria = prima * +this.valorUdi;
        this.leyendaSecundaria = 'Prima mensual: ';
        break;
      case 'ANUAL':

        this.lblPrimaUDISecundaria = 0;
        this.lblPrimaPesosSecundaria = 0;
        this.leyendaSecundaria = '';
        break;

    }

  }

  cargaEtiquetasSecundariasPesos(sumaPrimas): void {
    let prima = 0;
    let frecuencia = this.formaPagoForm.controls.frecuencia.value;
    this.lblPrimaUDISecundaria = 0;
    this.lblPrimaDolaresSecundaria = 0;
    switch (frecuencia) {
      case 'SEMESTRAL':
        prima = sumaPrimas / 2 * 1.035;
        this.lblPrimaPesosSecundaria = prima;
        this.leyendaSecundaria = 'Prima semestral: ';
        break;
      case 'TRIMESTRAL':
        prima = sumaPrimas / 4 * 1.05;
        this.lblPrimaPesosSecundaria = prima;
        this.leyendaSecundaria = 'Prima trimestral: ';
        break;
      case 'MENSUAL':
        prima = sumaPrimas / 12 * 1.06;
        this.lblPrimaPesosSecundaria = prima;
        this.leyendaSecundaria = 'Prima mensual: ';
        break;
      case 'ANUAL':

        this.lblPrimaUDISecundaria = 0;
        this.lblPrimaPesosSecundaria = 0;
        this.leyendaSecundaria = '';
        break;

    }


  }

  cargaEtiquetasSecundariasDolares(sumaPrimas): void {
    let prima = 0;
    let frecuencia = this.formaPagoForm.controls.frecuencia.value;
    this.lblPrimaUDISecundaria = 0;
    this.lblPrimaPesosSecundaria = 0;
    switch (frecuencia) {
      case 'SEMESTRAL':
        prima = sumaPrimas / 2 * 1.035;
        this.lblPrimaDolaresSecundaria = prima;
        this.leyendaSecundaria = 'Prima semestral: ';
        break;
      case 'TRIMESTRAL':
        prima = sumaPrimas / 4 * 1.05;
        this.lblPrimaDolaresSecundaria = prima;
        this.leyendaSecundaria = 'Prima trimestral: ';
        break;
      case 'MENSUAL':
        prima = sumaPrimas / 12 * 1.06;
        this.lblPrimaDolaresSecundaria = prima;
        this.leyendaSecundaria = 'Prima mensual: ';
        break;
      case 'ANUAL':

        this.lblPrimaUDISecundaria = 0;
        this.lblPrimaDolaresSecundaria = 0;
        this.leyendaSecundaria = '';
        break;

    }


  }

}
